module.exports = __webpack_public_path__ + "img/DK31374227.6e02d9ad.png";